var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var fancyTimeFormat = function (duration) {
    var hrs = ~~(duration / 3600);
    var mins = ~~((duration % 3600) / 60);
    var secs = ~~duration % 60;
    var ret = '';
    if (hrs > 0) {
        ret += '' + hrs + ':' + (mins < 10 ? '0' : '');
    }
    ret += '' + mins + ':' + (secs < 10 ? '0' : '');
    ret += '' + secs;
    return ret;
};
export var truncateTextWithEllipse = function (text, length) {
    if (length === void 0) { length = 30; }
    if (!text) {
        return '';
    }
    return text.length <= length ? text : "".concat(text.slice(0, length), "...");
};
export var resolveTotalTime = function (chunks) { return function () {
    var totalTime = chunks.reduce(function (acc, curr) { return acc + curr.end - curr.start; }, 0);
    return totalTime;
}; };
export var resolveSeekPosition = function (chunks) { return function (seekPercent) {
    var chunksWidthTime = chunks.reduce(function (acc, curr) {
        var prev = acc[acc.length - 1];
        var prevEnd = prev ? prev.total + prev.prevEnd : 0;
        return __spreadArray(__spreadArray([], acc, true), [
            {
                start: curr.start,
                end: curr.end,
                prevEnd: prevEnd,
                total: curr.end - curr.start
            }
        ], false);
    }, []);
    var totalTime = chunks.reduce(function (acc, curr) { return acc + curr.end - curr.start; }, 0);
    var timePosition = (totalTime * seekPercent) / 100;
    var matchingChunkIndex = chunksWidthTime.findIndex(function (c) {
        return c.prevEnd <= timePosition && c.prevEnd + c.total >= timePosition;
    });
    var matchingChunk = chunksWidthTime[matchingChunkIndex];
    return {
        index: matchingChunkIndex,
        chunkTime: matchingChunk.start + timePosition - matchingChunk.prevEnd
    };
}; };
export var resolveOverallTime = function (chunks) {
    return function (chunkIndex, chunkTime) {
        var chunksWidthTime = chunks.reduce(function (acc, curr) {
            var prev = acc[acc.length - 1];
            var prevEnd = prev ? prev.total + prev.prevEnd : 0;
            return __spreadArray(__spreadArray([], acc, true), [
                {
                    start: curr.start,
                    end: curr.end,
                    prevEnd: prevEnd,
                    total: curr.end - curr.start
                }
            ], false);
        }, []);
        var timeChunk = chunksWidthTime[chunkIndex];
        var timeProgress = Math.min(Math.max(chunkTime, timeChunk.start), timeChunk.end) -
            timeChunk.start;
        var chunkEndInSeconds = parseInt(timeChunk.end);
        var totalChunkInSeconds = parseInt(chunkTime.toString(), 10);
        return {
            playbackTime: timeChunk.prevEnd + timeProgress,
            isComplete: chunkEndInSeconds <= totalChunkInSeconds
        };
    };
};
//# sourceMappingURL=index.js.map